
import React , {useEffect, useState } from 'react';
// import {getMetaCategory} from "../../service/biboMartService";
import {getMetaCategories} from "../../service/myProductService";
// import Head from "../Head";
import { useLocation } from '@reach/router';
import {ItemDefault} from '../Products/Item'
import Breadcrumbs from '../Breadcrumbs';
import Menu from "../Menu";
import loadScript from '../Layout/loadScript';
import ReactHtmlParser from 'react-html-parser';

import "./listproduct.css"
import { navigate } from 'gatsby';

const Listproduct =(props)=> {
    const location = useLocation();
    let uri = location.pathname?.replace('.html','').replace('/','');
    const [meta, setMeta] = useState([]);
    const [showDes, setShowDes] = useState(false);
    const [category, setCategory] = useState();
    const [showAlert, setShowAlert] = useState(false);
    useEffect(()=>{
        try{
            getMetaCategories(uri).then((response)=>{
                if(+response.status === 200){
                        setMeta(response['message']);
                        window.localStorage.setItem('nameCategory', response['message']?.name);
                }else{
                    setMeta([]);
                    window.localStorage.setItem('nameCategory', '');
                }
            });
        }catch(e){console.log(e);}

        
//         var _array_cate = [];
//         var brc = [];
//         var _path = '';
//         JSON.parse(window.localStorage.getItem('itemCate')).map((item,i)=>{
//             );
//             if(item.url_key === uri){
//                 _path = item.path;
//             }else{
//                 // _array_cate.push(item);
//                 item.child?.map((childNode,j)=>{
//                     if(childNode.url_key === uri){
//                         _path = childNode.path;
//                     }else{
//                         // _array_cate.push(childNode);
//                         childNode.child1?.map((childNode1,k)=>{
//                             if(childNode.url_key === uri){
//                                 _path = childNode1.path;
//                             }
//                             // _array_cate.push(childNode1);
//                         })
//                     }
                   
//                 })
//             }
//         });
// console.log(_path);

//         JSON.parse(window.localStorage.getItem('itemCate')).map((item,i)=>{
//             if(item.path.includes(_path) === true){
//                 brc.push({ link: item.url_key, label: item.name });
//             }
//             item.child?.map((childNode,j)=>{
//                 if(childNode.path.includes(_path) === true){
//                     brc.push({ link: childNode.url_key, label: childNode.name });
//                 }
//             })
//         });

//         setCategory(_array_cate);

        loadMapScript();
        setTimeout(function(){
            window.localStorage.setItem('typepage', '');
        }, 1000);
            var _items = [];
            props.items.forEach((item) => {
                _items.push({ 
                    item_id: item.sku,
                    item_name: item.name,
                    price: +item.price?.discount
                });
              });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'items': _items
                    }
                });
                setShowAlert(true);
    },[]);
    const handleRedirect=(uri, name)=>{
        let _uri = "/"+uri+".html";
        window.localStorage.setItem('typepage', 'category');
        window.localStorage.setItem('nameCategory', name);
        navigate(_uri);
      }
  const [isShowCategory, setIsShowCategory] = useState(true);
  const handleShowCatagery=()=>{
    setIsShowCategory(!isShowCategory);
  }
  const [isShowColor, setIsShowColor] = useState(false);
  const handleShowColor=()=>{
    setIsShowColor(!isShowColor);
  }
  const [isShowSize, setIsShowSize] = useState(false);
  const handleShowSize=()=>{
    setIsShowSize(!isShowSize);
  }
  const [isShowBrand, setIsShowBrand] = useState(false);
  const handleShowBrand=()=>{
    setIsShowBrand(!isShowBrand);
  }
  const loadMapScript=()=> {
    loadScript('/static/css/style.js?onload=start')
      .then((script) => {
        // this.mapScript = script;
        // this.setState({ apiLoaded: true });
      })
      .catch((err) => {
        console.error(err.message);
      });
  }
  const toggleShowMore = () => {
    setShowDes(!showDes);
    if(showDes){
      window.scrollTo(0,700)
    }
  }
//   console.log(category);
  return (
    <>
    {/* <Head key="Head" item={meta}/> */}
    <div className="container page-builder-ltr ">
        <div className="container-menu">
            <Breadcrumbs key="Breadcrumbs"
            crumbs={[
                { link: '/', label: 'Trang chủ' },
                { label: window.localStorage.getItem('nameCategory') },
            ]}
            />
        </div>
    </div> 
   
    <div className='container page-builder-ltr'>
        <div className='row catalog-product '>
        <div className='page-builder-category'>
            <div className='category-list-group'>
            <div className='row col-md-12 mgx-0'>
                <div className='col-md-10'>
                    <span className='title'>Nhóm sản phẩm</span>
                </div>    
                <div className='text-center col-md-2' onClick={()=>handleShowCatagery()}>
                    {
                        isShowCategory ? (<i className="fa fa-angle-up"></i>):(<i className="fa fa-angle-down"></i>)
                    }
                    
                </div>
            </div>
           {
            isShowCategory ? (
                <div className='so-groups-sticky pdl-10'>
                    <div className='so-groups-sticky hidden-xs'>
                            <div className='nav-secondary fade-out'>
                                <ul>
                                {
                                   window.localStorage.getItem('itemCate') !== null && JSON.parse(window.localStorage.getItem('itemCate')).length > 0 ? (
                                        JSON.parse(window.localStorage.getItem('itemCate')).map((item,i)=>{
                                            return <li key={i}>
                                                {
                                                    item.child.length > 0 ?(
                                                        <span className="nav-action in-f">
                                                            <i className="fa fa-plus more"></i>
                                                            <i className="fa fa-minus less"></i>
                                                        </span>
                                                    ):(null)
                                                }
                                                {
                                                   item.url_key === uri ? window.localStorage.setItem('nameCategory', item.name) : null
                                                }
                                                <a href={"/"+item.url_key+".html"} className={item.url_key === uri ? "choosed" : ""}><i className="fa fa-chevron-down nav-arrow"></i> {item.name}</a>
                                                {
                                                    item.child.length > 0 ?(
                                                    <ul className="level-2">
                                                        {
                                                            item.child?.map((childNode,j)=>{
                                                                return  <li key={j}>
                                                                {
                                                                    childNode.child.length > 0 ?(
                                                                        <span className="nav-action">
                                                                            <i className="fa fa-plus more"></i>
                                                                            <i className="fa fa-minus less"></i>
                                                                        </span>
                                                                    ):(null)
                                                                }
                                                                 {
                                                                    childNode.url_key === uri ? window.localStorage.setItem('nameCategory', childNode.name) : null
                                                                }
                                                                <a href={"/"+childNode.url_key+".html"} className={childNode.url_key === uri ? "choosed" : ""} ><i className="fa fa-chevron-down nav-arrow"></i> {childNode.name}</a>
                                                                    
                                                                    {
                                                                        childNode.child.length > 0 ?(
                                                                        <ul className="level-3">
                                                                            {
                                                                                childNode.child?.map((childNode1,k)=>{
                                                                                return  <li key={k}>
                                                                                    {
                                                                                        childNode1.url_key === uri ? window.localStorage.setItem('nameCategory', childNode1.name) : null
                                                                                    }
                                                                                    <a href={"/"+childNode1.url_key+".html"} className={childNode1.url_key === uri ? "choosed" : ""}><i className="fa fa-chevron-down nav-arrow"></i> {childNode1.name}</a>
                                                                                    </li>
                                                                                })
                                                                            }
                                                                        </ul>
                                                                        ):(null)
                                                                    }
                                                                </li>
                                                            })
                                                        }
                                                    </ul>
                                                    ):(null)
                                                }
                                            </li>
                                        })
                                    ): (null)
                                }
                                </ul>
                            </div>
                        </div>       
                </div> 
            ):(null)
           }
            </div>

            {/* <div className='category-list-price'>
            <div className='list-price-header'>
                <span>Khoảng giá</span>
            </div>

            <div className='lits-price-content'>
                
            </div>
            </div>

            <div className='category-list-color'>  
            <div className='row col-md-12'>
                <div className='col-md-10'>
                    <span className='title'>Màu sắc</span>
                </div>    
                <div className='text-center col-md-2' onClick={()=>handleShowColor()}>
                    {
                          isShowColor ? (<i className="fa fa-angle-up"></i>):(<i className="fa fa-angle-down"></i>)
                    }
                    
                </div>
            </div>
            {
                isShowColor ? (
                    <ul className='list-color-content'>
                    <li className='color-content-detail'>
                        <div className='box-color-detail' style={{ backgroundColor: '#F8B61A' }}></div>
                        <span>Vàng</span>
                    </li>
    
                    <li className='color-content-detail'>
                        <div className='box-color-detail' style={{ backgroundColor: 'red' }}></div>
                        <span>Đỏ</span>
                    </li>
    
                    <li className='color-content-detail'>
                        <div className='box-color-detail' style={{ backgroundColor: 'blue' }}></div>
                        <span>Xanh</span>
                    </li>
    
                    <li className='color-content-detail'>
                        <div className='box-color-detail' style={{ backgroundColor: 'black' }}></div>
                        <span>Đen</span>
                    </li>
    
                    <li className='color-content-continue'>
                    <i className="fa fa-ellipsis"></i>
                    </li>
                </ul>
    
                ):(null)
            }

            </div>

            <div className='category-list-size'>
            <div className='row col-md-12'>
                <div className='col-md-10'>
                    <span className='title'>Kích thước</span>
                </div>    
                <div className='text-center col-md-2' onClick={()=>handleShowSize()}>
                {
                          isShowSize ? (<i className="fa fa-angle-up"></i>):(<i className="fa fa-angle-down"></i>)
                    }
                </div>
            </div>
            {
                isShowSize ? (
                    <ul className='list-size-content'>
                    <li className='size-content-detail'>
                    <span>{'2Y'}</span>
                    </li>
                    <li className='size-content-detail'>
                    <span>{'3Y'}</span>
                    </li>
                    <li className='size-content-detail'>
                    <span>{'3-4Y'}</span>
                    </li>
                    <li className='size-content-detail'>
                    <span>{'4-5Y'}</span>
                    </li>
                    <li className='size-content-detail'>
                    <span>{'0-6 tháng'}</span>
                    </li>
                </ul>
                ):(null)
            }
            
            </div>

            <div className='category-list-brand'>
            <div className='row col-md-12'>
                <div className='col-md-10'>
                    <span className='title'>Thương hiệu</span>
                </div>    
                <div className='text-center col-md-2' onClick={()=>handleShowBrand()}>
                {
                          isShowBrand ? (<i className="fa fa-angle-up"></i>):(<i className="fa fa-angle-down"></i>)
                    }
                </div>
            </div>
            {
                isShowBrand?(
                    <ul className='list-brand-content'>
                        <li className='brand-content-detail'>
                        <span>{'Anh'}</span>
                        </li>
                        <li className='brand-content-detail'>
                        <span>{'Ba Lan'}</span>
                        </li>
                        <li className='brand-content-detail'>
                        <span>{'Đài Loan'}</span>
                        </li>
                        <li className='brand-content-detail'>
                        <span>{'Đan Mạch'}</span>
                        </li>
                        <li className='brand-content-detail'>
                        <span>{'Nhật Bản'}</span>
                        </li>
                    </ul>
                ):(null)
            }
            
            </div>

            <div className='category-list-material'>
            <div className='row col-md-12'>
                <div className='col-md-10'>
                    <span className='title'>Chất liệu</span>
                </div>    
                <div className='text-center col-md-2'>
                    <i className="fa fa-angle-up"></i>
                </div>
            </div>
            <div className='list-material-content'>

            </div>
            </div> */}
        </div>
        <div className='pag-listitem'>
            <div className='row item-header mgx-0'>
                {/* <h1 className='d-none'>{window.localStorage.getItem('nameCategory')}</h1> */}
                <div className='col-md-10'><span className='text-baby uppercase'>{window.localStorage.getItem('nameCategory')}</span></div>
                    <div className='col-md-1'><span>Sắp xếp</span></div>
                    <div className='col-md-2 '>
                        <select>
                            <option>
                            Phổ biến nhất
                            </option>
                        </select>
                    </div>
                </div>
                <div className='row item-category-product mgx-0'>
                    <div className="wap-listing-tabs products-list grid">
                        <div className="ltabs-items-container">
                            <div className="products-list ltabs-items">
                                <div className="ltabs-items-inner">
                                    { 
                                        props.items.length > 0 ?(
                                            props.items?.map((item, index)=>(
                                                <div className='col-md-3 boder-list' key={index}>
                                                <ItemDefault key={index} item={item} index={index} isShowAddToCart={true} isShowCategoryName={true}/>
                                                </div>
                                            ))
                                        ):(
                                            showAlert ===true && props.items.length === 0 ?(
                                                <div className='message pdr-10'>
                                                    <div className='info'>
                                                    <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> <span>Không có sản phẩm phù hợp.</span>
                                                    </div>
                                                    
                                                </div>
                                            ):(<div id="landing-web">
                                            <div className="loading-page"  style={{textAlign:"center"}}>
                                                <img src="/../images/loading.gif" alt="icon"/>
                                            </div>
                                        </div>)
                                            
                                            // <div>Chưa có dữ liệu</div>
                                        )
                                        
                                    }
                                </div>
                            </div>
                            {
                                +props.datapage > 1 ? (
                                    <>
                                    <div className="col-md-12 ltabs-loadmore">
                                        <button className="btn-loadmore" id="loadmore" data-label="Load More" onClick={(e)=>props.parentCallback(e)} >
                                        <span className="ltabs-image-loading"></span>Xem thêm </button>
                                    </div>
                                    </>
                                ):(null)
                            }

                            <div className="col-md-12 mgt-20 pdr-10">
                                <div className="description">
                                    {showDes ? ReactHtmlParser(meta?.description) : ReactHtmlParser(meta?.description?.substring(0, 600))}
                                </div>

                                {meta?.description?.length > 600 && (
                                    <div className="row text-center">
                                    <a onClick={toggleShowMore}>
                                        <i className={showDes ? "fa fa-angle-up pdr-5" : "fa fa-angle-down pdr-5"}></i>
                                        {showDes ? "THU NHỎ" : "XEM THÊM"}
                                    </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    </div>
    <Menu key="menu"/>
    </>
  )
}

export default Listproduct;